import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { SharedModule } from 'src/app/shared/shared.module';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: true,
  imports: [CommonModule, PipesModule, DirectivesModule, SharedModule],
})
export class BannerComponent implements OnInit {
  @Input() title: string | null;
  @Input() subtitle: string = '';
  @Input() showBtn: boolean = false;
  @Input() isHomePage: boolean = false;
  populations = Populations;

  constructor() {}

  ngOnInit(): void {}
}
